{
    "assets": [
        {
            "id": "58",
            "layers": [
                {
                    "ind": 57,
                    "ty": 4,
                    "ks": {},
                    "ip": 0,
                    "op": 385,
                    "st": 0,
                    "shapes": [
                        {
                            "ty": "rc",
                            "p": { "a": 0, "k": [18.5, 30] },
                            "r": { "a": 0, "k": 0 },
                            "s": { "a": 0, "k": [37, 60] }
                        },
                        {
                            "ty": "fl",
                            "c": { "a": 0, "k": [0, 0, 0, 0] },
                            "o": { "a": 0, "k": 0 }
                        }
                    ]
                },
                {
                    "ind": 0,
                    "ty": 4,
                    "ks": { "s": { "a": 0, "k": [133.33, 133.33] } },
                    "ip": 0,
                    "op": 385,
                    "st": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ty": "gr",
                                    "it": [
                                        {
                                            "ty": "sh",
                                            "ks": {
                                                "a": 0,
                                                "k": {
                                                    "c": true,
                                                    "i": [
                                                        [0, 0],
                                                        [1.67, -0.92],
                                                        [0.04, -0.02],
                                                        [0.41, -1.27],
                                                        [0, -0.57],
                                                        [0, 0],
                                                        [0, 0],
                                                        [0, 0],
                                                        [0, -2.55],
                                                        [0, 0],
                                                        [0.23, -0.7],
                                                        [0.03, -0.07],
                                                        [0, 0],
                                                        [0, 1.95],
                                                        [0, 0],
                                                        [1.68, 0.97],
                                                        [0, 0]
                                                    ],
                                                    "o": [
                                                        [-1.65, -0.95],
                                                        [-0.03, 0.02],
                                                        [-1.18, 0.69],
                                                        [-0.16, 0.52],
                                                        [0, 0],
                                                        [0, 0],
                                                        [0, 0],
                                                        [2.21, 1.27],
                                                        [0, 0],
                                                        [0, 0.75],
                                                        [-0.02, 0.07],
                                                        [0, 0],
                                                        [1.69, -0.97],
                                                        [0, 0],
                                                        [0, -1.94],
                                                        [0, 0],
                                                        [0, 0]
                                                    ],
                                                    "v": [
                                                        [8.5, 0.73],
                                                        [3.15, 0.68],
                                                        [3.05, 0.74],
                                                        [0.59, 3.79],
                                                        [0.34, 5.44],
                                                        [0.34, 12.63],
                                                        [7.12, 16.54],
                                                        [9.35, 17.82],
                                                        [12.92, 24],
                                                        [12.92, 42.55],
                                                        [12.57, 44.73],
                                                        [12.5, 44.96],
                                                        [24.59, 37.98],
                                                        [27.31, 33.27],
                                                        [27.31, 14.71],
                                                        [24.59, 10.01],
                                                        [21.5, 8.23]
                                                    ]
                                                }
                                            }
                                        },
                                        {
                                            "ty": "fl",
                                            "c": {
                                                "a": 0,
                                                "k": [0.31, 0.32, 0.35, 1]
                                            },
                                            "r": 2,
                                            "o": { "a": 0, "k": 100 }
                                        },
                                        {
                                            "ty": "tr",
                                            "o": { "a": 0, "k": 100 }
                                        }
                                    ]
                                },
                                { "ty": "tr", "o": { "a": 0, "k": 100 } }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "id": "61",
            "layers": [
                {
                    "ind": 60,
                    "ty": 0,
                    "parent": 56,
                    "ks": {},
                    "w": 37,
                    "h": 60,
                    "ip": 0,
                    "op": 385,
                    "st": 0,
                    "refId": "58"
                },
                {
                    "ind": 56,
                    "ty": 3,
                    "ks": {
                        "a": { "a": 0, "k": [18.5, 30] },
                        "p": { "a": 0, "k": [18.5, 93] }
                    },
                    "ip": 0,
                    "op": 385,
                    "st": 0
                }
            ]
        },
        {
            "id": "53",
            "layers": [
                {
                    "ind": 6,
                    "ty": 4,
                    "parent": 5,
                    "ks": {},
                    "ip": 0,
                    "op": 385,
                    "st": 0,
                    "shapes": [
                        {
                            "ty": "sh",
                            "ks": {
                                "a": 0,
                                "k": {
                                    "c": true,
                                    "i": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [0, 33],
                                        [57, 0],
                                        [57, 57],
                                        [0, 90],
                                        [0, 33]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ]
                                }
                            }
                        },
                        {
                            "ty": "fl",
                            "c": { "a": 0, "k": [0.988, 0.655, 0] },
                            "o": { "a": 0, "k": 100 }
                        }
                    ]
                },
                {
                    "ind": 5,
                    "ty": 3,
                    "parent": 4,
                    "ks": { "p": { "a": 0, "k": [0, 1140] } },
                    "ip": 0,
                    "op": 385,
                    "st": 0
                },
                {
                    "ind": 8,
                    "ty": 4,
                    "parent": 7,
                    "ks": {},
                    "ip": 0,
                    "op": 385,
                    "st": 0,
                    "shapes": [
                        {
                            "ty": "sh",
                            "ks": {
                                "a": 0,
                                "k": {
                                    "c": true,
                                    "i": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [0, 33],
                                        [57, 0],
                                        [57, 57],
                                        [0, 90],
                                        [0, 33]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ]
                                }
                            }
                        },
                        {
                            "ty": "fl",
                            "c": { "a": 0, "k": [0.988, 0.655, 0] },
                            "o": { "a": 0, "k": 100 }
                        }
                    ]
                },
                {
                    "ind": 7,
                    "ty": 3,
                    "parent": 4,
                    "ks": { "p": { "a": 0, "k": [0, 912] } },
                    "ip": 0,
                    "op": 385,
                    "st": 0
                },
                {
                    "ind": 10,
                    "ty": 4,
                    "parent": 9,
                    "ks": {},
                    "ip": 0,
                    "op": 385,
                    "st": 0,
                    "shapes": [
                        {
                            "ty": "sh",
                            "ks": {
                                "a": 0,
                                "k": {
                                    "c": true,
                                    "i": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [0, 33],
                                        [57, 0],
                                        [57, 57],
                                        [0, 90],
                                        [0, 33]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ]
                                }
                            }
                        },
                        {
                            "ty": "fl",
                            "c": { "a": 0, "k": [0.988, 0.655, 0] },
                            "o": { "a": 0, "k": 100 }
                        }
                    ]
                },
                {
                    "ind": 9,
                    "ty": 3,
                    "parent": 4,
                    "ks": { "p": { "a": 0, "k": [0, 684] } },
                    "ip": 0,
                    "op": 385,
                    "st": 0
                },
                {
                    "ind": 12,
                    "ty": 4,
                    "parent": 11,
                    "ks": {},
                    "ip": 0,
                    "op": 385,
                    "st": 0,
                    "shapes": [
                        {
                            "ty": "sh",
                            "ks": {
                                "a": 0,
                                "k": {
                                    "c": true,
                                    "i": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [0, 33],
                                        [57, 0],
                                        [57, 57],
                                        [0, 90],
                                        [0, 33]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ]
                                }
                            }
                        },
                        {
                            "ty": "fl",
                            "c": { "a": 0, "k": [0.988, 0.655, 0] },
                            "o": { "a": 0, "k": 100 }
                        }
                    ]
                },
                {
                    "ind": 11,
                    "ty": 3,
                    "parent": 4,
                    "ks": { "p": { "a": 0, "k": [0, 456] } },
                    "ip": 0,
                    "op": 385,
                    "st": 0
                },
                {
                    "ind": 14,
                    "ty": 4,
                    "parent": 13,
                    "ks": {},
                    "ip": 0,
                    "op": 385,
                    "st": 0,
                    "shapes": [
                        {
                            "ty": "sh",
                            "ks": {
                                "a": 0,
                                "k": {
                                    "c": true,
                                    "i": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [0, 33],
                                        [57, 0],
                                        [57, 57],
                                        [0, 90],
                                        [0, 33]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ]
                                }
                            }
                        },
                        {
                            "ty": "fl",
                            "c": { "a": 0, "k": [0.988, 0.655, 0] },
                            "o": { "a": 0, "k": 100 }
                        }
                    ]
                },
                {
                    "ind": 13,
                    "ty": 3,
                    "parent": 4,
                    "ks": { "p": { "a": 0, "k": [0, 228] } },
                    "ip": 0,
                    "op": 385,
                    "st": 0
                },
                {
                    "ind": 16,
                    "ty": 4,
                    "parent": 15,
                    "ks": {},
                    "ip": 0,
                    "op": 385,
                    "st": 0,
                    "shapes": [
                        {
                            "ty": "sh",
                            "ks": {
                                "a": 0,
                                "k": {
                                    "c": true,
                                    "i": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [0, 33],
                                        [57, 0],
                                        [57, 57],
                                        [0, 90],
                                        [0, 33]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ]
                                }
                            }
                        },
                        {
                            "ty": "fl",
                            "c": { "a": 0, "k": [0.988, 0.655, 0] },
                            "o": { "a": 0, "k": 100 }
                        }
                    ]
                },
                {
                    "ind": 15,
                    "ty": 3,
                    "parent": 4,
                    "ks": {},
                    "ip": 0,
                    "op": 385,
                    "st": 0
                },
                {
                    "ind": 18,
                    "ty": 4,
                    "parent": 17,
                    "ks": {},
                    "ip": 0,
                    "op": 385,
                    "st": 0,
                    "shapes": [
                        {
                            "ty": "sh",
                            "ks": {
                                "a": 0,
                                "k": {
                                    "c": true,
                                    "i": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [0, 33],
                                        [57, 0],
                                        [57, 57],
                                        [0, 90],
                                        [0, 33]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ]
                                }
                            }
                        },
                        {
                            "ty": "fl",
                            "c": { "a": 0, "k": [0.094, 0.408, 0.859] },
                            "o": { "a": 0, "k": 100 }
                        }
                    ]
                },
                {
                    "ind": 17,
                    "ty": 3,
                    "parent": 4,
                    "ks": { "p": { "a": 0, "k": [0, 1311] } },
                    "ip": 0,
                    "op": 385,
                    "st": 0
                },
                {
                    "ind": 20,
                    "ty": 4,
                    "parent": 19,
                    "ks": {},
                    "ip": 0,
                    "op": 385,
                    "st": 0,
                    "shapes": [
                        {
                            "ty": "sh",
                            "ks": {
                                "a": 0,
                                "k": {
                                    "c": true,
                                    "i": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [0, 33],
                                        [57, 0],
                                        [57, 57],
                                        [0, 90],
                                        [0, 33]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ]
                                }
                            }
                        },
                        {
                            "ty": "fl",
                            "c": { "a": 0, "k": [0.094, 0.408, 0.859] },
                            "o": { "a": 0, "k": 100 }
                        }
                    ]
                },
                {
                    "ind": 19,
                    "ty": 3,
                    "parent": 4,
                    "ks": { "p": { "a": 0, "k": [0, 1083] } },
                    "ip": 0,
                    "op": 385,
                    "st": 0
                },
                {
                    "ind": 22,
                    "ty": 4,
                    "parent": 21,
                    "ks": {},
                    "ip": 0,
                    "op": 385,
                    "st": 0,
                    "shapes": [
                        {
                            "ty": "sh",
                            "ks": {
                                "a": 0,
                                "k": {
                                    "c": true,
                                    "i": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [0, 33],
                                        [57, 0],
                                        [57, 57],
                                        [0, 90],
                                        [0, 33]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ]
                                }
                            }
                        },
                        {
                            "ty": "fl",
                            "c": { "a": 0, "k": [0.094, 0.408, 0.859] },
                            "o": { "a": 0, "k": 100 }
                        }
                    ]
                },
                {
                    "ind": 21,
                    "ty": 3,
                    "parent": 4,
                    "ks": { "p": { "a": 0, "k": [0, 855] } },
                    "ip": 0,
                    "op": 385,
                    "st": 0
                },
                {
                    "ind": 24,
                    "ty": 4,
                    "parent": 23,
                    "ks": {},
                    "ip": 0,
                    "op": 385,
                    "st": 0,
                    "shapes": [
                        {
                            "ty": "sh",
                            "ks": {
                                "a": 0,
                                "k": {
                                    "c": true,
                                    "i": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [0, 33],
                                        [57, 0],
                                        [57, 57],
                                        [0, 90],
                                        [0, 33]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ]
                                }
                            }
                        },
                        {
                            "ty": "fl",
                            "c": { "a": 0, "k": [0.094, 0.408, 0.859] },
                            "o": { "a": 0, "k": 100 }
                        }
                    ]
                },
                {
                    "ind": 23,
                    "ty": 3,
                    "parent": 4,
                    "ks": { "p": { "a": 0, "k": [0, 627] } },
                    "ip": 0,
                    "op": 385,
                    "st": 0
                },
                {
                    "ind": 26,
                    "ty": 4,
                    "parent": 25,
                    "ks": {},
                    "ip": 0,
                    "op": 385,
                    "st": 0,
                    "shapes": [
                        {
                            "ty": "sh",
                            "ks": {
                                "a": 0,
                                "k": {
                                    "c": true,
                                    "i": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [0, 33],
                                        [57, 0],
                                        [57, 57],
                                        [0, 90],
                                        [0, 33]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ]
                                }
                            }
                        },
                        {
                            "ty": "fl",
                            "c": { "a": 0, "k": [0.094, 0.408, 0.859] },
                            "o": { "a": 0, "k": 100 }
                        }
                    ]
                },
                {
                    "ind": 25,
                    "ty": 3,
                    "parent": 4,
                    "ks": { "p": { "a": 0, "k": [0, 399] } },
                    "ip": 0,
                    "op": 385,
                    "st": 0
                },
                {
                    "ind": 28,
                    "ty": 4,
                    "parent": 27,
                    "ks": {},
                    "ip": 0,
                    "op": 385,
                    "st": 0,
                    "shapes": [
                        {
                            "ty": "sh",
                            "ks": {
                                "a": 0,
                                "k": {
                                    "c": true,
                                    "i": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [0, 33],
                                        [57, 0],
                                        [57, 57],
                                        [0, 90],
                                        [0, 33]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ]
                                }
                            }
                        },
                        {
                            "ty": "fl",
                            "c": { "a": 0, "k": [0.094, 0.408, 0.859] },
                            "o": { "a": 0, "k": 100 }
                        }
                    ]
                },
                {
                    "ind": 27,
                    "ty": 3,
                    "parent": 4,
                    "ks": { "p": { "a": 0, "k": [0, 171] } },
                    "ip": 0,
                    "op": 385,
                    "st": 0
                },
                {
                    "ind": 30,
                    "ty": 4,
                    "parent": 29,
                    "ks": {},
                    "ip": 0,
                    "op": 385,
                    "st": 0,
                    "shapes": [
                        {
                            "ty": "sh",
                            "ks": {
                                "a": 0,
                                "k": {
                                    "c": true,
                                    "i": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [0, 33],
                                        [57, 0],
                                        [57, 57],
                                        [0, 90],
                                        [0, 33]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ]
                                }
                            }
                        },
                        {
                            "ty": "fl",
                            "c": { "a": 0, "k": [0.416, 0.604, 0.137] },
                            "o": { "a": 0, "k": 100 }
                        }
                    ]
                },
                {
                    "ind": 29,
                    "ty": 3,
                    "parent": 4,
                    "ks": { "p": { "a": 0, "k": [0, 1254] } },
                    "ip": 0,
                    "op": 385,
                    "st": 0
                },
                {
                    "ind": 32,
                    "ty": 4,
                    "parent": 31,
                    "ks": {},
                    "ip": 0,
                    "op": 385,
                    "st": 0,
                    "shapes": [
                        {
                            "ty": "sh",
                            "ks": {
                                "a": 0,
                                "k": {
                                    "c": true,
                                    "i": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [0, 33],
                                        [57, 0],
                                        [57, 57],
                                        [0, 90],
                                        [0, 33]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ]
                                }
                            }
                        },
                        {
                            "ty": "fl",
                            "c": { "a": 0, "k": [0.416, 0.604, 0.137] },
                            "o": { "a": 0, "k": 100 }
                        }
                    ]
                },
                {
                    "ind": 31,
                    "ty": 3,
                    "parent": 4,
                    "ks": { "p": { "a": 0, "k": [0, 1026] } },
                    "ip": 0,
                    "op": 385,
                    "st": 0
                },
                {
                    "ind": 34,
                    "ty": 4,
                    "parent": 33,
                    "ks": {},
                    "ip": 0,
                    "op": 385,
                    "st": 0,
                    "shapes": [
                        {
                            "ty": "sh",
                            "ks": {
                                "a": 0,
                                "k": {
                                    "c": true,
                                    "i": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [0, 33],
                                        [57, 0],
                                        [57, 57],
                                        [0, 90],
                                        [0, 33]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ]
                                }
                            }
                        },
                        {
                            "ty": "fl",
                            "c": { "a": 0, "k": [0.416, 0.604, 0.137] },
                            "o": { "a": 0, "k": 100 }
                        }
                    ]
                },
                {
                    "ind": 33,
                    "ty": 3,
                    "parent": 4,
                    "ks": { "p": { "a": 0, "k": [0, 798] } },
                    "ip": 0,
                    "op": 385,
                    "st": 0
                },
                {
                    "ind": 36,
                    "ty": 4,
                    "parent": 35,
                    "ks": {},
                    "ip": 0,
                    "op": 385,
                    "st": 0,
                    "shapes": [
                        {
                            "ty": "sh",
                            "ks": {
                                "a": 0,
                                "k": {
                                    "c": true,
                                    "i": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [0, 33],
                                        [57, 0],
                                        [57, 57],
                                        [0, 90],
                                        [0, 33]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ]
                                }
                            }
                        },
                        {
                            "ty": "fl",
                            "c": { "a": 0, "k": [0.416, 0.604, 0.137] },
                            "o": { "a": 0, "k": 100 }
                        }
                    ]
                },
                {
                    "ind": 35,
                    "ty": 3,
                    "parent": 4,
                    "ks": { "p": { "a": 0, "k": [0, 570] } },
                    "ip": 0,
                    "op": 385,
                    "st": 0
                },
                {
                    "ind": 38,
                    "ty": 4,
                    "parent": 37,
                    "ks": {},
                    "ip": 0,
                    "op": 385,
                    "st": 0,
                    "shapes": [
                        {
                            "ty": "sh",
                            "ks": {
                                "a": 0,
                                "k": {
                                    "c": true,
                                    "i": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [0, 33],
                                        [57, 0],
                                        [57, 57],
                                        [0, 90],
                                        [0, 33]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ]
                                }
                            }
                        },
                        {
                            "ty": "fl",
                            "c": { "a": 0, "k": [0.416, 0.604, 0.137] },
                            "o": { "a": 0, "k": 100 }
                        }
                    ]
                },
                {
                    "ind": 37,
                    "ty": 3,
                    "parent": 4,
                    "ks": { "p": { "a": 0, "k": [0, 342] } },
                    "ip": 0,
                    "op": 385,
                    "st": 0
                },
                {
                    "ind": 40,
                    "ty": 4,
                    "parent": 39,
                    "ks": {},
                    "ip": 0,
                    "op": 385,
                    "st": 0,
                    "shapes": [
                        {
                            "ty": "sh",
                            "ks": {
                                "a": 0,
                                "k": {
                                    "c": true,
                                    "i": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [0, 33],
                                        [57, 0],
                                        [57, 57],
                                        [0, 90],
                                        [0, 33]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ]
                                }
                            }
                        },
                        {
                            "ty": "fl",
                            "c": { "a": 0, "k": [0.416, 0.604, 0.137] },
                            "o": { "a": 0, "k": 100 }
                        }
                    ]
                },
                {
                    "ind": 39,
                    "ty": 3,
                    "parent": 4,
                    "ks": { "p": { "a": 0, "k": [0, 114] } },
                    "ip": 0,
                    "op": 385,
                    "st": 0
                },
                {
                    "ind": 42,
                    "ty": 4,
                    "parent": 41,
                    "ks": {},
                    "ip": 0,
                    "op": 385,
                    "st": 0,
                    "shapes": [
                        {
                            "ty": "sh",
                            "ks": {
                                "a": 0,
                                "k": {
                                    "c": true,
                                    "i": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [0, 33],
                                        [57, 0],
                                        [57, 57],
                                        [0, 90],
                                        [0, 33]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ]
                                }
                            }
                        },
                        {
                            "ty": "fl",
                            "c": { "a": 0, "k": [0.686, 0.349, 0.882] },
                            "o": { "a": 0, "k": 100 }
                        }
                    ]
                },
                {
                    "ind": 41,
                    "ty": 3,
                    "parent": 4,
                    "ks": { "p": { "a": 0, "k": [0, 1197] } },
                    "ip": 0,
                    "op": 385,
                    "st": 0
                },
                {
                    "ind": 44,
                    "ty": 4,
                    "parent": 43,
                    "ks": {},
                    "ip": 0,
                    "op": 385,
                    "st": 0,
                    "shapes": [
                        {
                            "ty": "sh",
                            "ks": {
                                "a": 0,
                                "k": {
                                    "c": true,
                                    "i": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [0, 33],
                                        [57, 0],
                                        [57, 57],
                                        [0, 90],
                                        [0, 33]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ]
                                }
                            }
                        },
                        {
                            "ty": "fl",
                            "c": { "a": 0, "k": [0.686, 0.349, 0.882] },
                            "o": { "a": 0, "k": 100 }
                        }
                    ]
                },
                {
                    "ind": 43,
                    "ty": 3,
                    "parent": 4,
                    "ks": { "p": { "a": 0, "k": [0, 969] } },
                    "ip": 0,
                    "op": 385,
                    "st": 0
                },
                {
                    "ind": 46,
                    "ty": 4,
                    "parent": 45,
                    "ks": {},
                    "ip": 0,
                    "op": 385,
                    "st": 0,
                    "shapes": [
                        {
                            "ty": "sh",
                            "ks": {
                                "a": 0,
                                "k": {
                                    "c": true,
                                    "i": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [0, 33],
                                        [57, 0],
                                        [57, 57],
                                        [0, 90],
                                        [0, 33]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ]
                                }
                            }
                        },
                        {
                            "ty": "fl",
                            "c": { "a": 0, "k": [0.686, 0.349, 0.882] },
                            "o": { "a": 0, "k": 100 }
                        }
                    ]
                },
                {
                    "ind": 45,
                    "ty": 3,
                    "parent": 4,
                    "ks": { "p": { "a": 0, "k": [0, 741] } },
                    "ip": 0,
                    "op": 385,
                    "st": 0
                },
                {
                    "ind": 48,
                    "ty": 4,
                    "parent": 47,
                    "ks": {},
                    "ip": 0,
                    "op": 385,
                    "st": 0,
                    "shapes": [
                        {
                            "ty": "sh",
                            "ks": {
                                "a": 0,
                                "k": {
                                    "c": true,
                                    "i": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [0, 33],
                                        [57, 0],
                                        [57, 57],
                                        [0, 90],
                                        [0, 33]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ]
                                }
                            }
                        },
                        {
                            "ty": "fl",
                            "c": { "a": 0, "k": [0.686, 0.349, 0.882] },
                            "o": { "a": 0, "k": 100 }
                        }
                    ]
                },
                {
                    "ind": 47,
                    "ty": 3,
                    "parent": 4,
                    "ks": { "p": { "a": 0, "k": [0, 513] } },
                    "ip": 0,
                    "op": 385,
                    "st": 0
                },
                {
                    "ind": 50,
                    "ty": 4,
                    "parent": 49,
                    "ks": {},
                    "ip": 0,
                    "op": 385,
                    "st": 0,
                    "shapes": [
                        {
                            "ty": "sh",
                            "ks": {
                                "a": 0,
                                "k": {
                                    "c": true,
                                    "i": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [0, 33],
                                        [57, 0],
                                        [57, 57],
                                        [0, 90],
                                        [0, 33]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ]
                                }
                            }
                        },
                        {
                            "ty": "fl",
                            "c": { "a": 0, "k": [0.686, 0.349, 0.882] },
                            "o": { "a": 0, "k": 100 }
                        }
                    ]
                },
                {
                    "ind": 49,
                    "ty": 3,
                    "parent": 4,
                    "ks": { "p": { "a": 0, "k": [0, 285] } },
                    "ip": 0,
                    "op": 385,
                    "st": 0
                },
                {
                    "ind": 52,
                    "ty": 4,
                    "parent": 51,
                    "ks": {},
                    "ip": 0,
                    "op": 385,
                    "st": 0,
                    "shapes": [
                        {
                            "ty": "sh",
                            "ks": {
                                "a": 0,
                                "k": {
                                    "c": true,
                                    "i": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [0, 33],
                                        [57, 0],
                                        [57, 57],
                                        [0, 90],
                                        [0, 33]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ]
                                }
                            }
                        },
                        {
                            "ty": "fl",
                            "c": { "a": 0, "k": [0.686, 0.349, 0.882] },
                            "o": { "a": 0, "k": 100 }
                        }
                    ]
                },
                {
                    "ind": 51,
                    "ty": 3,
                    "parent": 4,
                    "ks": { "p": { "a": 0, "k": [0, 57] } },
                    "ip": 0,
                    "op": 385,
                    "st": 0
                },
                {
                    "ind": 4,
                    "ty": 3,
                    "parent": 3,
                    "ks": {
                        "a": { "a": 0, "k": [28.5, 700.5] },
                        "p": {
                            "a": 1,
                            "k": [
                                {
                                    "t": 0,
                                    "s": [28.5, -439.5],
                                    "i": { "x": [1, 0.5], "y": [1, 1] },
                                    "o": { "x": [0, 0.5], "y": [0, 0] }
                                },
                                {
                                    "t": 192,
                                    "s": [28.5, -325.5],
                                    "i": { "x": [1, 0.5], "y": [1, 1] },
                                    "o": { "x": [0, 0.5], "y": [0, 0] }
                                },
                                { "t": 384, "s": [28.5, -211.5], "h": 1 }
                            ]
                        }
                    },
                    "ip": 0,
                    "op": 385,
                    "st": 0
                },
                {
                    "ind": 3,
                    "ty": 3,
                    "ks": { "p": { "a": 0, "k": [0, 1140] } },
                    "ip": 0,
                    "op": 385,
                    "st": 0
                }
            ]
        },
        {
            "id": "120",
            "layers": [
                {
                    "ind": 119,
                    "ty": 4,
                    "ks": {},
                    "ip": 0,
                    "op": 385,
                    "st": 0,
                    "shapes": [
                        {
                            "ty": "rc",
                            "p": { "a": 0, "k": [18, 30] },
                            "r": { "a": 0, "k": 0 },
                            "s": { "a": 0, "k": [36, 60] }
                        },
                        {
                            "ty": "fl",
                            "c": { "a": 0, "k": [0, 0, 0, 0] },
                            "o": { "a": 0, "k": 0 }
                        }
                    ]
                },
                {
                    "ind": 0,
                    "ty": 4,
                    "ks": { "s": { "a": 0, "k": [133.33, 133.33] } },
                    "ip": 0,
                    "op": 385,
                    "st": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ty": "gr",
                                    "it": [
                                        {
                                            "ty": "sh",
                                            "ks": {
                                                "a": 0,
                                                "k": {
                                                    "c": true,
                                                    "i": [
                                                        [0, 0],
                                                        [0, 0],
                                                        [0, -1.95],
                                                        [0, 0],
                                                        [-1.68, -0.97],
                                                        [0, 0],
                                                        [0, 0],
                                                        [-1.67, 0.92],
                                                        [-0.04, 0.02],
                                                        [-0.41, 1.27],
                                                        [0, 0.57],
                                                        [0, 0],
                                                        [0, 0],
                                                        [0, 0],
                                                        [0, 2.55],
                                                        [0, 0],
                                                        [-0.22, 0.7],
                                                        [-0.03, 0.07]
                                                    ],
                                                    "o": [
                                                        [0, 0],
                                                        [-1.69, 0.97],
                                                        [0, 0],
                                                        [0, 1.94],
                                                        [0, 0],
                                                        [0, 0],
                                                        [1.66, 0.95],
                                                        [0.03, -0.02],
                                                        [1.19, -0.68],
                                                        [0.17, -0.52],
                                                        [0, 0],
                                                        [0, 0],
                                                        [0, 0],
                                                        [-2.21, -1.27],
                                                        [0, 0],
                                                        [0, -0.75],
                                                        [0.03, -0.07],
                                                        [0, 0]
                                                    ],
                                                    "v": [
                                                        [14.81, 0],
                                                        [2.72, 6.97],
                                                        [0, 11.68],
                                                        [0, 30.24],
                                                        [2.73, 34.95],
                                                        [5.59, 36.61],
                                                        [18.8, 44.23],
                                                        [24.16, 44.28],
                                                        [24.26, 44.21],
                                                        [26.72, 41.16],
                                                        [26.98, 39.52],
                                                        [26.98, 32.33],
                                                        [19.98, 28.3],
                                                        [17.96, 27.13],
                                                        [14.39, 20.96],
                                                        [14.39, 2.41],
                                                        [14.73, 0.23],
                                                        [14.81, 0]
                                                    ]
                                                }
                                            }
                                        },
                                        {
                                            "ty": "fl",
                                            "c": {
                                                "a": 0,
                                                "k": [0.31, 0.32, 0.35, 1]
                                            },
                                            "r": 2,
                                            "o": { "a": 0, "k": 100 }
                                        },
                                        {
                                            "ty": "tr",
                                            "o": { "a": 0, "k": 100 }
                                        }
                                    ]
                                },
                                { "ty": "tr", "o": { "a": 0, "k": 100 } }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "id": "123",
            "layers": [
                {
                    "ind": 122,
                    "ty": 0,
                    "parent": 118,
                    "ks": {},
                    "w": 36,
                    "h": 60,
                    "ip": 0,
                    "op": 385,
                    "st": 0,
                    "refId": "120"
                },
                {
                    "ind": 118,
                    "ty": 3,
                    "ks": {
                        "a": { "a": 0, "k": [18, 30] },
                        "p": { "a": 0, "k": [39, 168.63] }
                    },
                    "ip": 0,
                    "op": 385,
                    "st": 0
                }
            ]
        },
        {
            "id": "115",
            "layers": [
                {
                    "ind": 68,
                    "ty": 4,
                    "parent": 67,
                    "ks": {},
                    "ip": 0,
                    "op": 385,
                    "st": 0,
                    "shapes": [
                        {
                            "ty": "sh",
                            "ks": {
                                "a": 0,
                                "k": {
                                    "c": true,
                                    "i": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [0, 33],
                                        [57, 0],
                                        [57, 57],
                                        [0, 90],
                                        [0, 33]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ]
                                }
                            }
                        },
                        {
                            "ty": "fl",
                            "c": { "a": 0, "k": [0.988, 0.655, 0] },
                            "o": { "a": 0, "k": 100 }
                        }
                    ]
                },
                {
                    "ind": 67,
                    "ty": 3,
                    "parent": 66,
                    "ks": { "p": { "a": 0, "k": [0, 57] } },
                    "ip": 0,
                    "op": 385,
                    "st": 0
                },
                {
                    "ind": 70,
                    "ty": 4,
                    "parent": 69,
                    "ks": {},
                    "ip": 0,
                    "op": 385,
                    "st": 0,
                    "shapes": [
                        {
                            "ty": "sh",
                            "ks": {
                                "a": 0,
                                "k": {
                                    "c": true,
                                    "i": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [0, 33],
                                        [57, 0],
                                        [57, 57],
                                        [0, 90],
                                        [0, 33]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ]
                                }
                            }
                        },
                        {
                            "ty": "fl",
                            "c": { "a": 0, "k": [0.988, 0.655, 0] },
                            "o": { "a": 0, "k": 100 }
                        }
                    ]
                },
                {
                    "ind": 69,
                    "ty": 3,
                    "parent": 66,
                    "ks": { "p": { "a": 0, "k": [0, 285] } },
                    "ip": 0,
                    "op": 385,
                    "st": 0
                },
                {
                    "ind": 72,
                    "ty": 4,
                    "parent": 71,
                    "ks": {},
                    "ip": 0,
                    "op": 385,
                    "st": 0,
                    "shapes": [
                        {
                            "ty": "sh",
                            "ks": {
                                "a": 0,
                                "k": {
                                    "c": true,
                                    "i": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [0, 33],
                                        [57, 0],
                                        [57, 57],
                                        [0, 90],
                                        [0, 33]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ]
                                }
                            }
                        },
                        {
                            "ty": "fl",
                            "c": { "a": 0, "k": [0.988, 0.655, 0] },
                            "o": { "a": 0, "k": 100 }
                        }
                    ]
                },
                {
                    "ind": 71,
                    "ty": 3,
                    "parent": 66,
                    "ks": { "p": { "a": 0, "k": [0, 1197] } },
                    "ip": 0,
                    "op": 385,
                    "st": 0
                },
                {
                    "ind": 74,
                    "ty": 4,
                    "parent": 73,
                    "ks": {},
                    "ip": 0,
                    "op": 385,
                    "st": 0,
                    "shapes": [
                        {
                            "ty": "sh",
                            "ks": {
                                "a": 0,
                                "k": {
                                    "c": true,
                                    "i": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [0, 33],
                                        [57, 0],
                                        [57, 57],
                                        [0, 90],
                                        [0, 33]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ]
                                }
                            }
                        },
                        {
                            "ty": "fl",
                            "c": { "a": 0, "k": [0.988, 0.655, 0] },
                            "o": { "a": 0, "k": 100 }
                        }
                    ]
                },
                {
                    "ind": 73,
                    "ty": 3,
                    "parent": 66,
                    "ks": { "p": { "a": 0, "k": [0, 969] } },
                    "ip": 0,
                    "op": 385,
                    "st": 0
                },
                {
                    "ind": 76,
                    "ty": 4,
                    "parent": 75,
                    "ks": {},
                    "ip": 0,
                    "op": 385,
                    "st": 0,
                    "shapes": [
                        {
                            "ty": "sh",
                            "ks": {
                                "a": 0,
                                "k": {
                                    "c": true,
                                    "i": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [0, 33],
                                        [57, 0],
                                        [57, 57],
                                        [0, 90],
                                        [0, 33]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ]
                                }
                            }
                        },
                        {
                            "ty": "fl",
                            "c": { "a": 0, "k": [0.988, 0.655, 0] },
                            "o": { "a": 0, "k": 100 }
                        }
                    ]
                },
                {
                    "ind": 75,
                    "ty": 3,
                    "parent": 66,
                    "ks": { "p": { "a": 0, "k": [0, 741] } },
                    "ip": 0,
                    "op": 385,
                    "st": 0
                },
                {
                    "ind": 78,
                    "ty": 4,
                    "parent": 77,
                    "ks": {},
                    "ip": 0,
                    "op": 385,
                    "st": 0,
                    "shapes": [
                        {
                            "ty": "sh",
                            "ks": {
                                "a": 0,
                                "k": {
                                    "c": true,
                                    "i": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [0, 33],
                                        [57, 0],
                                        [57, 57],
                                        [0, 90],
                                        [0, 33]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ]
                                }
                            }
                        },
                        {
                            "ty": "fl",
                            "c": { "a": 0, "k": [0.988, 0.655, 0] },
                            "o": { "a": 0, "k": 100 }
                        }
                    ]
                },
                {
                    "ind": 77,
                    "ty": 3,
                    "parent": 66,
                    "ks": { "p": { "a": 0, "k": [0, 513] } },
                    "ip": 0,
                    "op": 385,
                    "st": 0
                },
                {
                    "ind": 80,
                    "ty": 4,
                    "parent": 79,
                    "ks": {},
                    "ip": 0,
                    "op": 385,
                    "st": 0,
                    "shapes": [
                        {
                            "ty": "sh",
                            "ks": {
                                "a": 0,
                                "k": {
                                    "c": true,
                                    "i": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [0, 33],
                                        [57, 0],
                                        [57, 57],
                                        [0, 90],
                                        [0, 33]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ]
                                }
                            }
                        },
                        {
                            "ty": "fl",
                            "c": { "a": 0, "k": [0.094, 0.408, 0.859] },
                            "o": { "a": 0, "k": 100 }
                        }
                    ]
                },
                {
                    "ind": 79,
                    "ty": 3,
                    "parent": 66,
                    "ks": { "p": { "a": 0, "k": [0, 114] } },
                    "ip": 0,
                    "op": 385,
                    "st": 0
                },
                {
                    "ind": 82,
                    "ty": 4,
                    "parent": 81,
                    "ks": {},
                    "ip": 0,
                    "op": 385,
                    "st": 0,
                    "shapes": [
                        {
                            "ty": "sh",
                            "ks": {
                                "a": 0,
                                "k": {
                                    "c": true,
                                    "i": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [0, 33],
                                        [57, 0],
                                        [57, 57],
                                        [0, 90],
                                        [0, 33]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ]
                                }
                            }
                        },
                        {
                            "ty": "fl",
                            "c": { "a": 0, "k": [0.094, 0.408, 0.859] },
                            "o": { "a": 0, "k": 100 }
                        }
                    ]
                },
                {
                    "ind": 81,
                    "ty": 3,
                    "parent": 66,
                    "ks": { "p": { "a": 0, "k": [0, 342] } },
                    "ip": 0,
                    "op": 385,
                    "st": 0
                },
                {
                    "ind": 84,
                    "ty": 4,
                    "parent": 83,
                    "ks": {},
                    "ip": 0,
                    "op": 385,
                    "st": 0,
                    "shapes": [
                        {
                            "ty": "sh",
                            "ks": {
                                "a": 0,
                                "k": {
                                    "c": true,
                                    "i": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [0, 33],
                                        [57, 0],
                                        [57, 57],
                                        [0, 90],
                                        [0, 33]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ]
                                }
                            }
                        },
                        {
                            "ty": "fl",
                            "c": { "a": 0, "k": [0.094, 0.408, 0.859] },
                            "o": { "a": 0, "k": 100 }
                        }
                    ]
                },
                {
                    "ind": 83,
                    "ty": 3,
                    "parent": 66,
                    "ks": { "p": { "a": 0, "k": [0, 1254] } },
                    "ip": 0,
                    "op": 385,
                    "st": 0
                },
                {
                    "ind": 86,
                    "ty": 4,
                    "parent": 85,
                    "ks": {},
                    "ip": 0,
                    "op": 385,
                    "st": 0,
                    "shapes": [
                        {
                            "ty": "sh",
                            "ks": {
                                "a": 0,
                                "k": {
                                    "c": true,
                                    "i": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [0, 33],
                                        [57, 0],
                                        [57, 57],
                                        [0, 90],
                                        [0, 33]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ]
                                }
                            }
                        },
                        {
                            "ty": "fl",
                            "c": { "a": 0, "k": [0.094, 0.408, 0.859] },
                            "o": { "a": 0, "k": 100 }
                        }
                    ]
                },
                {
                    "ind": 85,
                    "ty": 3,
                    "parent": 66,
                    "ks": { "p": { "a": 0, "k": [0, 1026] } },
                    "ip": 0,
                    "op": 385,
                    "st": 0
                },
                {
                    "ind": 88,
                    "ty": 4,
                    "parent": 87,
                    "ks": {},
                    "ip": 0,
                    "op": 385,
                    "st": 0,
                    "shapes": [
                        {
                            "ty": "sh",
                            "ks": {
                                "a": 0,
                                "k": {
                                    "c": true,
                                    "i": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [0, 33],
                                        [57, 0],
                                        [57, 57],
                                        [0, 90],
                                        [0, 33]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ]
                                }
                            }
                        },
                        {
                            "ty": "fl",
                            "c": { "a": 0, "k": [0.094, 0.408, 0.859] },
                            "o": { "a": 0, "k": 100 }
                        }
                    ]
                },
                {
                    "ind": 87,
                    "ty": 3,
                    "parent": 66,
                    "ks": { "p": { "a": 0, "k": [0, 798] } },
                    "ip": 0,
                    "op": 385,
                    "st": 0
                },
                {
                    "ind": 90,
                    "ty": 4,
                    "parent": 89,
                    "ks": {},
                    "ip": 0,
                    "op": 385,
                    "st": 0,
                    "shapes": [
                        {
                            "ty": "sh",
                            "ks": {
                                "a": 0,
                                "k": {
                                    "c": true,
                                    "i": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [0, 33],
                                        [57, 0],
                                        [57, 57],
                                        [0, 90],
                                        [0, 33]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ]
                                }
                            }
                        },
                        {
                            "ty": "fl",
                            "c": { "a": 0, "k": [0.094, 0.408, 0.859] },
                            "o": { "a": 0, "k": 100 }
                        }
                    ]
                },
                {
                    "ind": 89,
                    "ty": 3,
                    "parent": 66,
                    "ks": { "p": { "a": 0, "k": [0, 570] } },
                    "ip": 0,
                    "op": 385,
                    "st": 0
                },
                {
                    "ind": 92,
                    "ty": 4,
                    "parent": 91,
                    "ks": {},
                    "ip": 0,
                    "op": 385,
                    "st": 0,
                    "shapes": [
                        {
                            "ty": "sh",
                            "ks": {
                                "a": 0,
                                "k": {
                                    "c": true,
                                    "i": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [0, 33],
                                        [57, 0],
                                        [57, 57],
                                        [0, 90],
                                        [0, 33]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ]
                                }
                            }
                        },
                        {
                            "ty": "fl",
                            "c": { "a": 0, "k": [0.416, 0.604, 0.137] },
                            "o": { "a": 0, "k": 100 }
                        }
                    ]
                },
                {
                    "ind": 91,
                    "ty": 3,
                    "parent": 66,
                    "ks": { "p": { "a": 0, "k": [0, 171] } },
                    "ip": 0,
                    "op": 385,
                    "st": 0
                },
                {
                    "ind": 94,
                    "ty": 4,
                    "parent": 93,
                    "ks": {},
                    "ip": 0,
                    "op": 385,
                    "st": 0,
                    "shapes": [
                        {
                            "ty": "sh",
                            "ks": {
                                "a": 0,
                                "k": {
                                    "c": true,
                                    "i": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [0, 33],
                                        [57, 0],
                                        [57, 57],
                                        [0, 90],
                                        [0, 33]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ]
                                }
                            }
                        },
                        {
                            "ty": "fl",
                            "c": { "a": 0, "k": [0.416, 0.604, 0.137] },
                            "o": { "a": 0, "k": 100 }
                        }
                    ]
                },
                {
                    "ind": 93,
                    "ty": 3,
                    "parent": 66,
                    "ks": { "p": { "a": 0, "k": [0, 399] } },
                    "ip": 0,
                    "op": 385,
                    "st": 0
                },
                {
                    "ind": 96,
                    "ty": 4,
                    "parent": 95,
                    "ks": {},
                    "ip": 0,
                    "op": 385,
                    "st": 0,
                    "shapes": [
                        {
                            "ty": "sh",
                            "ks": {
                                "a": 0,
                                "k": {
                                    "c": true,
                                    "i": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [0, 33],
                                        [57, 0],
                                        [57, 57],
                                        [0, 90],
                                        [0, 33]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ]
                                }
                            }
                        },
                        {
                            "ty": "fl",
                            "c": { "a": 0, "k": [0.416, 0.604, 0.137] },
                            "o": { "a": 0, "k": 100 }
                        }
                    ]
                },
                {
                    "ind": 95,
                    "ty": 3,
                    "parent": 66,
                    "ks": { "p": { "a": 0, "k": [0, 1311] } },
                    "ip": 0,
                    "op": 385,
                    "st": 0
                },
                {
                    "ind": 98,
                    "ty": 4,
                    "parent": 97,
                    "ks": {},
                    "ip": 0,
                    "op": 385,
                    "st": 0,
                    "shapes": [
                        {
                            "ty": "sh",
                            "ks": {
                                "a": 0,
                                "k": {
                                    "c": true,
                                    "i": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [0, 33],
                                        [57, 0],
                                        [57, 57],
                                        [0, 90],
                                        [0, 33]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ]
                                }
                            }
                        },
                        {
                            "ty": "fl",
                            "c": { "a": 0, "k": [0.416, 0.604, 0.137] },
                            "o": { "a": 0, "k": 100 }
                        }
                    ]
                },
                {
                    "ind": 97,
                    "ty": 3,
                    "parent": 66,
                    "ks": { "p": { "a": 0, "k": [0, 1083] } },
                    "ip": 0,
                    "op": 385,
                    "st": 0
                },
                {
                    "ind": 100,
                    "ty": 4,
                    "parent": 99,
                    "ks": {},
                    "ip": 0,
                    "op": 385,
                    "st": 0,
                    "shapes": [
                        {
                            "ty": "sh",
                            "ks": {
                                "a": 0,
                                "k": {
                                    "c": true,
                                    "i": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [0, 33],
                                        [57, 0],
                                        [57, 57],
                                        [0, 90],
                                        [0, 33]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ]
                                }
                            }
                        },
                        {
                            "ty": "fl",
                            "c": { "a": 0, "k": [0.416, 0.604, 0.137] },
                            "o": { "a": 0, "k": 100 }
                        }
                    ]
                },
                {
                    "ind": 99,
                    "ty": 3,
                    "parent": 66,
                    "ks": { "p": { "a": 0, "k": [0, 855] } },
                    "ip": 0,
                    "op": 385,
                    "st": 0
                },
                {
                    "ind": 102,
                    "ty": 4,
                    "parent": 101,
                    "ks": {},
                    "ip": 0,
                    "op": 385,
                    "st": 0,
                    "shapes": [
                        {
                            "ty": "sh",
                            "ks": {
                                "a": 0,
                                "k": {
                                    "c": true,
                                    "i": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [0, 33],
                                        [57, 0],
                                        [57, 57],
                                        [0, 90],
                                        [0, 33]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ]
                                }
                            }
                        },
                        {
                            "ty": "fl",
                            "c": { "a": 0, "k": [0.416, 0.604, 0.137] },
                            "o": { "a": 0, "k": 100 }
                        }
                    ]
                },
                {
                    "ind": 101,
                    "ty": 3,
                    "parent": 66,
                    "ks": { "p": { "a": 0, "k": [0, 627] } },
                    "ip": 0,
                    "op": 385,
                    "st": 0
                },
                {
                    "ind": 104,
                    "ty": 4,
                    "parent": 103,
                    "ks": {},
                    "ip": 0,
                    "op": 385,
                    "st": 0,
                    "shapes": [
                        {
                            "ty": "sh",
                            "ks": {
                                "a": 0,
                                "k": {
                                    "c": true,
                                    "i": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [0, 33],
                                        [57, 0],
                                        [57, 57],
                                        [0, 90],
                                        [0, 33]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ]
                                }
                            }
                        },
                        {
                            "ty": "fl",
                            "c": { "a": 0, "k": [0.686, 0.349, 0.882] },
                            "o": { "a": 0, "k": 100 }
                        }
                    ]
                },
                {
                    "ind": 103,
                    "ty": 3,
                    "parent": 66,
                    "ks": { "p": { "a": 0, "k": [0, 0] } },
                    "ip": 0,
                    "op": 385,
                    "st": 0
                },
                {
                    "ind": 106,
                    "ty": 4,
                    "parent": 105,
                    "ks": {},
                    "ip": 0,
                    "op": 385,
                    "st": 0,
                    "shapes": [
                        {
                            "ty": "sh",
                            "ks": {
                                "a": 0,
                                "k": {
                                    "c": true,
                                    "i": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [0, 33],
                                        [57, 0],
                                        [57, 57],
                                        [0, 90],
                                        [0, 33]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ]
                                }
                            }
                        },
                        {
                            "ty": "fl",
                            "c": { "a": 0, "k": [0.686, 0.349, 0.882] },
                            "o": { "a": 0, "k": 100 }
                        }
                    ]
                },
                {
                    "ind": 105,
                    "ty": 3,
                    "parent": 66,
                    "ks": { "p": { "a": 0, "k": [0, 228] } },
                    "ip": 0,
                    "op": 385,
                    "st": 0
                },
                {
                    "ind": 108,
                    "ty": 4,
                    "parent": 107,
                    "ks": {},
                    "ip": 0,
                    "op": 385,
                    "st": 0,
                    "shapes": [
                        {
                            "ty": "sh",
                            "ks": {
                                "a": 0,
                                "k": {
                                    "c": true,
                                    "i": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [0, 33],
                                        [57, 0],
                                        [57, 57],
                                        [0, 90],
                                        [0, 33]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ]
                                }
                            }
                        },
                        {
                            "ty": "fl",
                            "c": { "a": 0, "k": [0.686, 0.349, 0.882] },
                            "o": { "a": 0, "k": 100 }
                        }
                    ]
                },
                {
                    "ind": 107,
                    "ty": 3,
                    "parent": 66,
                    "ks": { "p": { "a": 0, "k": [0, 1140] } },
                    "ip": 0,
                    "op": 385,
                    "st": 0
                },
                {
                    "ind": 110,
                    "ty": 4,
                    "parent": 109,
                    "ks": {},
                    "ip": 0,
                    "op": 385,
                    "st": 0,
                    "shapes": [
                        {
                            "ty": "sh",
                            "ks": {
                                "a": 0,
                                "k": {
                                    "c": true,
                                    "i": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [0, 33],
                                        [57, 0],
                                        [57, 57],
                                        [0, 90],
                                        [0, 33]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ]
                                }
                            }
                        },
                        {
                            "ty": "fl",
                            "c": { "a": 0, "k": [0.686, 0.349, 0.882] },
                            "o": { "a": 0, "k": 100 }
                        }
                    ]
                },
                {
                    "ind": 109,
                    "ty": 3,
                    "parent": 66,
                    "ks": { "p": { "a": 0, "k": [0, 912] } },
                    "ip": 0,
                    "op": 385,
                    "st": 0
                },
                {
                    "ind": 112,
                    "ty": 4,
                    "parent": 111,
                    "ks": {},
                    "ip": 0,
                    "op": 385,
                    "st": 0,
                    "shapes": [
                        {
                            "ty": "sh",
                            "ks": {
                                "a": 0,
                                "k": {
                                    "c": true,
                                    "i": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [0, 33],
                                        [57, 0],
                                        [57, 57],
                                        [0, 90],
                                        [0, 33]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ]
                                }
                            }
                        },
                        {
                            "ty": "fl",
                            "c": { "a": 0, "k": [0.686, 0.349, 0.882] },
                            "o": { "a": 0, "k": 100 }
                        }
                    ]
                },
                {
                    "ind": 111,
                    "ty": 3,
                    "parent": 66,
                    "ks": { "p": { "a": 0, "k": [0, 684] } },
                    "ip": 0,
                    "op": 385,
                    "st": 0
                },
                {
                    "ind": 114,
                    "ty": 4,
                    "parent": 113,
                    "ks": {},
                    "ip": 0,
                    "op": 385,
                    "st": 0,
                    "shapes": [
                        {
                            "ty": "sh",
                            "ks": {
                                "a": 0,
                                "k": {
                                    "c": true,
                                    "i": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [0, 33],
                                        [57, 0],
                                        [57, 57],
                                        [0, 90],
                                        [0, 33]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ]
                                }
                            }
                        },
                        {
                            "ty": "fl",
                            "c": { "a": 0, "k": [0.686, 0.349, 0.882] },
                            "o": { "a": 0, "k": 100 }
                        }
                    ]
                },
                {
                    "ind": 113,
                    "ty": 3,
                    "parent": 66,
                    "ks": { "p": { "a": 0, "k": [0, 456] } },
                    "ip": 0,
                    "op": 385,
                    "st": 0
                },
                {
                    "ind": 66,
                    "ty": 3,
                    "parent": 65,
                    "ks": {
                        "a": { "a": 0, "k": [28.5, 700.5] },
                        "p": {
                            "a": 1,
                            "k": [
                                {
                                    "t": 0,
                                    "s": [28.5, 700.5],
                                    "i": { "x": [1, 0.5], "y": [1, 1] },
                                    "o": { "x": [0, 0.5], "y": [0, 0] }
                                },
                                {
                                    "t": 192,
                                    "s": [28.5, 586.5],
                                    "i": { "x": [1, 0.5], "y": [1, 1] },
                                    "o": { "x": [0, 0.5], "y": [0, 0] }
                                },
                                { "t": 384, "s": [28.5, 472.5], "h": 1 }
                            ]
                        }
                    },
                    "ip": 0,
                    "op": 385,
                    "st": 0
                },
                {
                    "ind": 65,
                    "ty": 3,
                    "ks": { "p": { "a": 0, "k": [1, 229] } },
                    "ip": 0,
                    "op": 385,
                    "st": 0
                }
            ]
        }
    ],
    "fr": 60,
    "h": 64,
    "ip": 0,
    "layers": [
        {
            "ind": 63,
            "ty": 0,
            "td": 1,
            "parent": 2,
            "ks": {},
            "w": 37,
            "h": 123,
            "ip": 0,
            "op": 385,
            "st": 0,
            "refId": "61"
        },
        {
            "ind": 55,
            "ty": 0,
            "tt": 1,
            "parent": 2,
            "ks": { "a": { "a": 0, "k": [0, 1140] } },
            "w": 57,
            "h": 2541,
            "ip": 0,
            "op": 385,
            "st": 0,
            "refId": "53"
        },
        {
            "ind": 2,
            "ty": 3,
            "parent": 1,
            "ks": { "p": { "a": 0, "k": [25, -63] } },
            "ip": 0,
            "op": 385,
            "st": 0
        },
        {
            "ind": 125,
            "ty": 0,
            "td": 1,
            "parent": 64,
            "ks": {},
            "w": 57,
            "h": 199,
            "ip": 0,
            "op": 385,
            "st": 0,
            "refId": "123"
        },
        {
            "ind": 117,
            "ty": 0,
            "tt": 1,
            "parent": 64,
            "ks": { "a": { "a": 0, "k": [1, 229] } },
            "w": 58,
            "h": 1630,
            "ip": 0,
            "op": 385,
            "st": 0,
            "refId": "115"
        },
        {
            "ind": 64,
            "ty": 3,
            "parent": 1,
            "ks": { "p": { "a": 0, "k": [-17, -134.63] } },
            "ip": 0,
            "op": 385,
            "st": 0
        },
        {
            "ind": 1,
            "ty": 3,
            "parent": 0,
            "ks": {},
            "ip": 0,
            "op": 385,
            "st": 0
        },
        { "ind": 0, "ty": 3, "ks": {}, "ip": 0, "op": 385, "st": 0 }
    ],
    "meta": { "g": "https://jitter.video" },
    "op": 384,
    "v": "5.7.4",
    "w": 64
}
